// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 443 ? "about" : chunkId) + "." + {"197":"4a93619b","443":"cd47cdba","565":"a5e41e1c","642":"b7546dcc","839":"bd762f15","968":"9e8ac2dd"}[chunkId] + ".js";
};